<div class="cube-main-container">
    <canvas #canvas id="canvas"
        [class.blurred]="state === 3"
        (mousemove)="mouseMove($event)"
        (mousedown)="mouseDown($event)"
        (mouseup)="mouseUp($event)"
        (mouseleave)="mouseUp($event)"
        (touchmove)="mouseMove($event)"
        (touchstart)="mouseDown($event)"
        (touchend)="mouseUp($event)"
        (touchcancel)="mouseUp($event)">
    </canvas>
</div>